import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const accountType = localStorage.getItem("accountType") || "Buyer";

export const PostApi = createApi({
  reducerPath: "PostApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_APIENDPOINT}`,
  }),

  endpoints: (builder) => ({
    userLogin: builder.mutation({
      query: ({ accountType, language, ...body }) => {
        return {
          url: "auth/login",
          method: "PUT",
          body,
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),

    verifyOtp: builder.mutation({
      query: ({ language, ...body }) => {
        return {
          url: "auth/verifyOTP",
          method: "PATCH",
          body,
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    changeNotificationSettings: builder.mutation({
      query: ({ language, userToken, ...body }) => {
        return {
          url: "auth/changeNotification",
          method: "PATCH",
          body,
          headers: {
            "x-auth-language": language,
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    createPaymentIntent: builder.mutation({
      query: ({ accountType, userToken, ...body }) => {
        return {
          url: "transaction/createPaymentIntent",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    changeLanguage: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "auth/changeLanguage",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
            // "x-auth-language": language,
          },
        };
      },
    }),
    purchaseSubscription: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "transaction/purchaseSubscription",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getUserSubscriptionPlan: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "transaction/getUserSubscriptionPlan",
          method: "GET",
          // body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getAdminBankDetails: builder.mutation({
      query: ({ userToken, accountType }) => {
        return {
          url: "user/getAdminBankDetails",
          method: "GET",
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    addressSuggestion: builder.mutation({
      query: ({ userToken, url }) => {
        return {
          url: `user/addressSuggestion/${url}`,
          method: "GET",
          // body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getCompleteAddress: builder.mutation({
      query: ({ userToken, url }) => {
        return {
          url: `user/getCompleteAddress/${url}`,
          method: "GET",
          // body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    forgetPassword: builder.mutation({
      query: ({ language, accountType, ...body }) => {
        return {
          url: "auth/forgetPassword",
          method: "PATCH",
          body,
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getCategory: builder.mutation({
      query: ({ search, language }) => {
        return {
          url: "category/getAllCategories",
          method: "PATCH",
          body: { search },
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getSubscriptionsPlans: builder.mutation({
      query: ({ search, userToken }) => {
        return {
          url: "transaction/getSubscriptionsPlans",
          method: "PATCH",
          // body: { search },
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getTopSeller: builder.mutation({
      query: ({ search, language, userToken }) => {
        return {
          url: "inventory/getTopSeller",
          method: "PATCH",
          body: { search },
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getChemicalTender: builder.mutation({
      query: ({ search, language, userToken }) => {
        return {
          url: "inventory/getChemicalTender",
          method: "PATCH",
          body: { search },
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getSearchResult: builder.mutation({
      query: ({ search, language, userToken }) => {
        return {
          url: "inventory/getSearchResult",
          method: "PATCH",
          body: { search },
          headers: {
            "x-auth-language": language,
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getQueryResult: builder.mutation({
      query: ({ query, language, userToken }) => {
        return {
          url: "inventory/getQueryResult",
          method: "PATCH",
          body: { query },
          headers: {
            "x-auth-language": language,
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    placeQuotationOrder: builder.mutation({
      query: ({ language, userToken, accountType, ...data }) => {
        return {
          url: "order/placeQuotationOrder",
          method: "PATCH",
          body: data,
          headers: {
            "x-auth-language": language,
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getAllSubCategories: builder.mutation({
      query: ({ category, language, userToken }) => {
        return {
          url: "category/getAllSubCategories",
          method: "PATCH",
          body: { category },
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    updatePassword: builder.mutation({
      query: ({ language, accountType, ...body }) => {
        return {
          url: "auth/updatePassword",
          method: "PATCH",
          body,
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
          },
        };
      },
    }),
    changePassword: builder.mutation({
      query: ({ userToken, accountType, ...body }) => {
        return {
          url: "auth/changePassword",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getSellerProducts: builder.mutation({
      query: ({ userToken, accountType, ...body }) => {
        return {
          url: "inventory/getSellerProducts",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getUserContents: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "platform/getUserContents",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getAddresses: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "user/getAddresses",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getProducts: builder.mutation({
      query: ({ language, userToken, ...body }) => {
        return {
          url: "inventory/getProducts",
          method: "PATCH",
          body,
          headers: {
            "x-auth-language": language,
            "x-user-type": accountType,
            "x-auth-token-user": userToken,
          },
        };
      },
    }),
    getMyOrders: builder.mutation({
      query: ({ userToken, accountType, ...body }) => {
        console.log("accountType", body);

        return {
          url: "order/getMyOrders",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getAllIndustries: builder.mutation({
      query: ({ language, userToken, ...body }) => {
        return {
          url: "category/getAllIndustries",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
            "x-auth-language": language,
          },
        };
      },
    }),
    getRequirements: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "order/getRequirements",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getProductRatings: builder.mutation({
      query: ({ userToken, ...body }) => {
        return {
          url: "inventory/getProductRatings",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    getNotifications: builder.mutation({
      query: ({ userToken, language, ...body }) => {
        return {
          url: "notification/getNotifications",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
            "x-auth-language": language,
          },
        };
      },
    }),
    getUserDocuments: builder.mutation({
      query: ({ userToken, accountType, ...body }) => {
        return {
          url: "inventory/getUserDocuments",
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    generatePaymentInvoice: builder.mutation({
      query: ({ userToken, accountType, id, ...body }) => {
        return {
          url: `order/generatePaymentInvoice/${id}`,
          method: "PATCH",
          body,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
          },
        };
      },
    }),
    signup: builder.mutation({
      query: ({ formData, language }) => ({
        url: "auth/signup",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-language": language,
          "x-user-type": accountType,
        },
      }),
    }),
    uploadMedia: builder.mutation({
      query: ({ formData, language, userToken }) => ({
        url: "chat/uploadMedia",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-language": language,
          "x-user-type": accountType,
          "x-auth-token-user": userToken,
        },
      }),
    }),
    addSellerProduct: builder.mutation({
      query: ({ formData, accountType, userToken }) => ({
        url: "inventory/addSellerProduct",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    addAddress: builder.mutation({
      query: ({ userToken, ...data }) => ({
        url: "user/addAddress",
        method: "POST",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    raiseTicket: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: "platform/raiseTicket",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    createRequirement: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: "order/createRequirement",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    requestDocument: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: "inventory/requestDocument",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    placeOrder: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: "order/placeOrder",
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    bidRequirement: builder.mutation({
      query: ({ userToken, ...data }) => ({
        url: "order/bidRequirement",
        method: "POST",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    editProfile: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: "auth/editProfile",
        method: "PUT",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    updateFCM: builder.mutation({
      query: ({ userToken, ...data }) => ({
        url: "auth/updateFCM",
        method: "PUT",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    logout: builder.mutation({
      query: ({ language, userToken }) => ({
        url: "auth/logout",
        method: "PUT",
        // body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    editInventory: builder.mutation({
      query: ({ formData, userToken, id }) => ({
        url: `platform/editInventory/${id}`,
        method: "PUT",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    editSellerProduct: builder.mutation({
      query: ({ formData, userToken, id }) => ({
        url: `inventory/editSellerProduct/${id}`,
        method: "PUT",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    rateProduct: builder.mutation({
      query: ({ formData, userToken }) => ({
        url: `inventory/rateProduct`,
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    provideDocument: builder.mutation({
      query: ({ formData, userToken, id }) => ({
        url: `inventory/provideDocument/${id}`,
        method: "PATCH",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),

    getAIRecommendation: builder.mutation({
      query: ({ userToken, accountType, language, ...data }) => {
        console.log("Language in API call:", language);
        return {
          url: `inventory/getAIRecommendation`,
          method: "PATCH",
          body: data,
          headers: {
            "x-auth-token-user": userToken,
            "x-user-type": accountType,
            "x-auth-language": language,
          },
        };
      },
    }),

    proceedPayment: builder.mutation({
      query: ({ userToken, accountType, formData }) => ({
        url: `transaction/proceedPayment`,
        method: "PATCH",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    generateDeliveryInvoice: builder.mutation({
      query: ({ userToken, accountType, id, ...data }) => ({
        url: `order/generateDeliveryInvoice/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    getUserTransactions: builder.mutation({
      query: ({ userToken, ...data }) => ({
        url: `transaction/getUserTransactions`,
        method: "PATCH",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    changeStatus: builder.mutation({
      query: ({ userToken, id, ...data }) => ({
        url: `order/changeStatus/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    changeProductStatus: builder.mutation({
      query: ({ userToken, id, ...data }) => ({
        url: `inventory/changeProductStatus/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    acceptOrder: builder.mutation({
      query: ({ userToken, accountType, ids, ...data }) => ({
        url: `order/acceptOrder/${ids}`,
        method: "PATCH",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    rejectOrder: builder.mutation({
      query: ({ userToken, accountType, ids }) => ({
        url: `order/rejectOrder/${ids}`,
        method: "PATCH",
        // body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    editRating: builder.mutation({
      query: ({ formData, userToken, id }) => ({
        url: `inventory/editRating/${id}`,
        method: "POST",
        body: formData,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    editAddress: builder.mutation({
      query: ({ userToken, id, ...data }) => ({
        url: `user/editAddress/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    getUserProfile: builder.mutation({
      query: ({ userToken }) => ({
        url: `auth/getUserProfile/${userToken}`,
        method: "GET",
      }),
    }),
    viewSeller: builder.mutation({
      query: ({ userToken, accountType, language, ids }) => ({
        url: `inventory/viewSeller/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
          "x-auth-language": language,
        },
      }),
    }),
    getUserWalletInfo: builder.mutation({
      query: ({ userToken, ids }) => ({
        url: `transaction/getUserWalletInfo`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    viewChemicalTender: builder.mutation({
      query: ({ userToken, language, ids }) => ({
        url: `inventory/viewChemicalTender/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
          "x-auth-language": language,
        },
      }),
    }),
    acceptBid: builder.mutation({
      query: ({ userToken, id }) => ({
        url: `order/acceptBid/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    rejectBid: builder.mutation({
      query: ({ userToken, id }) => ({
        url: `order/rejectBid/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    addForPromotion: builder.mutation({
      query: ({ userToken, ids }) => ({
        url: `inventory/addForPromotion/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    viewDocument: builder.mutation({
      query: ({ userToken, ids, accountType }) => ({
        url: `inventory/viewDocument/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    readNotification: builder.mutation({
      query: ({ userToken, id }) => ({
        url: `notification/readNotification/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    getSearchHistory: builder.mutation({
      query: ({ userToken, id }) => ({
        url: `inventory/getSearchHistory`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    viewProduct: builder.mutation({
      query: ({ userToken, accountType, language, ids }) => ({
        url: `inventory/viewProduct/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
          "x-auth-language": language,
        },
      }),
    }),
    viewOrder: builder.mutation({
      query: ({ userToken, ids, accountType }) => ({
        url: `order/viewOrder/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    viewProductBuyer: builder.mutation({
      query: ({ userToken, accountType, language, ids }) => ({
        url: `inventory/viewProduct/${ids}`,
        method: "GET",
        headers: {
          "x-auth-language": language,
          "x-user-type": accountType,
          "x-auth-token-user": userToken,
        },
      }),
    }),
    viewSubCategory: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `category/viewSubCategory/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    blockUser: builder.mutation({
      query: ({ id, accountType, userToken }) => ({
        url: `chat/blockUser/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    unblockUser: builder.mutation({
      query: ({ id, accountType, userToken }) => ({
        url: `chat/unblockUser/${id}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    viewRequirement: builder.mutation({
      query: ({ ids, userToken }) => ({
        url: `order/viewRequirement/${ids}`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    getUser: builder.mutation({
      query: ({ userToken }) => ({
        url: `auth/getUser`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    getUserTicket: builder.mutation({
      query: ({ userToken }) => ({
        url: `platform/getUserTicket`,
        method: "GET",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    deleteAddress: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `user/deleteAddress/${id}`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    removeHistory: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `inventory/removeHistory/${id}`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    clearHistory: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `inventory/clearHistory`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    deleteNotification: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `notification/deleteNotification`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    deleteProduct: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `inventory/deleteProduct/${id}`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
    deleteChat: builder.mutation({
      query: ({ id, userToken }) => ({
        url: `chat/deleteChat/${id}`,
        method: "DELETE",
        headers: {
          "x-auth-token-user": userToken,
          "x-user-type": accountType,
        },
      }),
    }),
  }),
});

export const {
  useUserLoginMutation,
  useVerifyOtpMutation,
  useSignupMutation,
  useForgetPasswordMutation,
  useGetCategoryMutation,
  useGetUserProfileMutation,
  useUpdatePasswordMutation,
  useGetUserMutation,
  useEditProfileMutation,
  useGetTopSellerMutation,
  useGetChemicalTenderMutation,
  useChangePasswordMutation,
  useViewSubCategoryMutation,
  useGetAllSubCategoriesMutation,
  useAddSellerProductMutation,
  useGetSellerProductsMutation,
  useGetUserContentsMutation,
  useRaiseTicketMutation,
  useViewProductMutation,
  useGetUserTicketMutation,
  useGetSearchResultMutation,
  useAddForPromotionMutation,
  useGetProductsMutation,
  useViewProductBuyerMutation,
  usePlaceOrderMutation,
  useGetMyOrdersMutation,
  useViewOrderMutation,
  useViewSellerMutation,
  useGetAddressesMutation,
  useAddAddressMutation,
  useEditAddressMutation,
  useDeleteAddressMutation,
  useGetNotificationsMutation,
  useReadNotificationMutation,
  useGetSearchHistoryMutation,
  useRemoveHistoryMutation,
  useClearHistoryMutation,
  useDeleteNotificationMutation,
  useGetRequirementsMutation,
  useCreateRequirementMutation,
  useViewRequirementMutation,
  useEditInventoryMutation,
  useGetAllIndustriesMutation,
  useBidRequirementMutation,
  useAcceptBidMutation,
  useRejectBidMutation,
  useGetSubscriptionsPlansMutation,
  useRateProductMutation,
  useGetProductRatingsMutation,
  useEditRatingMutation,
  useChangeNotificationSettingsMutation,
  useChangeLanguageMutation,
  usePurchaseSubscriptionMutation,
  useGetUserSubscriptionPlanMutation,
  useRequestDocumentMutation,
  useGetUserDocumentsMutation,
  useViewDocumentMutation,
  useLogoutMutation,
  useViewChemicalTenderMutation,
  useProvideDocumentMutation,
  useGetUserTransactionsMutation,
  useGetUserWalletInfoMutation,
  useUploadMediaMutation,
  useGetAIRecommendationMutation,
  useChangeStatusMutation,
  useDeleteProductMutation,
  useEditSellerProductMutation,
  useBlockUserMutation,
  useDeleteChatMutation,
  useUpdateFCMMutation,
  useAcceptOrderMutation,
  useAddressSuggestionMutation,
  useGetCompleteAddressMutation,
  useGeneratePaymentInvoiceMutation,
  useCreatePaymentIntentMutation,
  useProceedPaymentMutation,
  useRejectOrderMutation,
  useGetAdminBankDetailsMutation,
  useGenerateDeliveryInvoiceMutation,
  useUnblockUserMutation,
  useChangeProductStatusMutation,
  useGetQueryResultMutation,
  usePlaceQuotationOrderMutation,
} = PostApi;
